<section id="eventLiveDetailWrap" class="event-live-detail-wrap">
    <div class="overlay blur" (click)="hideDetails()"></div>
    <div class="event-live-detail-container"> <!-- because of iPhone, sticky widget was blinking-->
      <section id="eventLiveDetail" class="event-live-detail" [class.live]="expandedEvent.isLive && expandedEvent.betRadarEventId" [attr.data-sportId]="expandedEvent.sportId">
        <div class="top-wrap">
          <div class="close-button" (click)="hideDetails()">X</div>
          <h2>
            <div class="icon-chart" *ngIf="viewConfigurations.showH2HwidgetOnDetail && expandedEvent.betRadarEventId" (click)="matchPreviewWidget(); $event.stopPropagation();">
              <span class="sporticon icon-sm sporticon-chart"></span>
            </div>
            {{expandedEvent.regionName}} {{expandedEvent.competitionName}}
          </h2>
        </div>
        <!-- <app-streaming-widget [isFullSize]="false" *ngIf="expandedEvent.isLive; else prematch" [betRadarEventId]="expandedEvent.betRadarEventId"></app-streaming-widget> -->
        <!-- <app-streaming-wrap [isWidgetFullSize]="true" *ngIf="expandedEvent.isLive; else prematch"></app-streaming-wrap> -->
        <div class="bottom-wrap" id="bottomWrap">
          <div id="streamingWidgetWrap" class="streaming-widget-wrap" *ngIf="expandedEvent.isLive && expandedEvent.betRadarEventId; else prematch">
            <app-streaming-wrap [class.hide]="widgetErrorMessage" [isWidgetFullSize]="true" *ngIf="expandedEvent.isLive"></app-streaming-wrap>
            <ng-container *ngIf="!(widgetErrorMessage && viewConfigurations.hideWidgetIfNotLicensed) else prematch"></ng-container>
          </div>
          <ng-template #prematch>
            <div class="event-name">
              <ng-container *ngIf="!expandedEvent.result">
                <div class="icon-chart" *ngIf="viewConfigurations.showH2HwidgetOnDetail && expandedEvent.betRadarEventId" (click)="headToHeadWidget(); $event.stopPropagation();">
                  <span class="sporticon icon-sm sporticon-chart"></span>
                </div>
                {{expandedEvent.eventName}}
              </ng-container>
              <ng-container *ngIf="expandedEvent.result">
                <span class="name">{{expandedEvent.homeTeam}}</span>
                <span>{{expandedEvent.result.score}}</span>
                <span class="name">{{expandedEvent.awayTeam}}</span>
              </ng-container>
            </div>
          </ng-template>
          <div class="line"></div>
          <div id="betMenuWrap" class="bet-menu-wrap" [class.center]="!isAnyGroupActive">
            <section class="loader-wrap" *ngIf="!isAnyGroupActive || !expandedEvent.isPlayable || !expandedEvent.isInOffer">
              <div class="text" *ngIf="expandedEvent.status !== eventStatusEnum.Finished" i18n="No Active Bets message@@EventDetailsNoActiveBets">Događaj trenutno nema aktivnih kvota, čeka se na ponudu</div>
              <div class="text" *ngIf="expandedEvent.status === eventStatusEnum.Finished" i18n="Event Finished@@EventFinished">Događaj je završen</div>
              <div class="spinner" *ngIf="expandedEvent.status !== eventStatusEnum.Finished"></div>
            </section>
            <ng-container *ngIf="expandedEvent.status !== eventStatusEnum.Finished && expandedEvent.isPlayable && expandedEvent.isInOffer">
              <ng-container *ngFor="let betTypeGroup of betTypeGroups">
                <span [class.selected]="betTypeGroup.isSelected" *ngIf="betTypeGroup.isOnline" (click)="selectGroup(betTypeGroup)">
                    {{betTypeGroup.name | lowercase}}
                  </span>
                </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="bet-type-wrap" *ngIf="expandedEvent.status !== eventStatusEnum.Finished && expandedEvent.isPlayable && expandedEvent.isInOffer">
          <ng-container *ngIf="selectedBetTypeGroup">
            <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems">
              <!-- mozda setovati index i na exact sbv pa pitati isAnyBetPlayable samo kad je all a za ostale slucajeve pitati da li je bets[index].isPlayable -->
              <article class="single-bet-type-wrap" *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId] && filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId].isAnyBetPlayable;">
                  <ng-container *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]; let betAndBetTypeShowTypeForExpandedEvent;">
                    <div class="bet-type-name" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameHeaderRow
                    && betAndBetTypeShowTypeForExpandedEvent.isAnyBetPlayable &&
                    betTypeGroupingTemplateItem.sbvSelectionType == SBVSelectionEnum.All">
                      <div class="flex">
                          <span *ngIf="expandedEvent.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</span>
                          <span *ngIf="expandedEvent.eventType == eventTypeENUM.Outright">{{betAndBetTypeShowTypeForExpandedEvent.betTypeOutrightName}}</span>
                          <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}" (click)="showTitle($event)">
                            <i class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i>
                            <!-- <span class="description-title"></span> -->
                          </span>
                          <!-- <span class="icon cashout" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled">
                            <span class="sporticon sporticon-transaction icon-ex-sm" title="Casheback"></span>
                          </span> -->
                      </div>
                    </div>
                    <div class="bets-conatainer bets-in-row-{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.numberOfBetsInRow}}">
                      <ng-container *ngFor="let bet of betAndBetTypeShowTypeForExpandedEvent.bets; let i = index;" >
                        <div class="single-bet"  *ngIf="
                        bet.isPlayable &&
                        bet.hasPlayableOutcomes &&
                        (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.All ||
                        (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.MostBalanced && betAndBetTypeShowTypeForExpandedEvent.mostBalancedBetIndex == i) ||
                        (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.Exact && bet.sbv === betTypeGroupingTemplateItem.sbvExactValue))
                        ">
                          <div class="bet-type-name" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameSameRow || betTypeGroupingTemplateItem.sbvSelectionType != SBVSelectionEnum.All">
                            <div class="flex">
                                <span *ngIf="expandedEvent.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</span>
                                <span *ngIf="expandedEvent.eventType == eventTypeENUM.Outright">{{bet.outrightName}}</span>
                                <span class="sbv" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.sbvDisplayType === SBVDisplayTypeEnum.SBVInBetType">
                                  <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                                  <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                                </span>
                                <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}" (click)="showTitle($event)">
                                  <i class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i>
                                  <!-- <span class="description-title"></span> -->
                                </span>
                                <!-- <span class="icon cashout" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled">
                                  <span class="sporticon sporticon-transaction icon-ex-sm" title="Casheback"></span>
                                </span> -->
                            </div>
                          </div>
                          <div class="bet-outcomes-wrap" [ngClass]="{'one-column': betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 1 && bet.betOutcomesDic[betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList[0].id].length == 1,
                           'two-column': betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 2 || (betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 1 && bet.betOutcomesDic[betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList[0].id].length == 2)}" *ngIf="betAndBetTypeShowTypeForExpandedEvent.isExpanded" >
                            <ng-container *ngFor="let bto of betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList">
                                <ng-container *ngTemplateOutlet="outcome; context:{bet: bet, betTypeOutcome: bto, betTypeShowType: betAndBetTypeShowTypeForExpandedEvent.betTypeShowType}">
                                </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
              </article>
            </ng-container>
          </ng-container>
          <ng-template #outcome let-bet="bet" let-betTypeOutcome="betTypeOutcome" let-betTypeShowType="betTypeShowType">
              <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVAlone; else sbvInBetTypeOrOutcome;">
                <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
                  <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                    <div class="outcome-wrap">
                        <div class="outcome {{betOutcome.higherLowerOdd}}" [ngClass]="{'selected': betOutcome.isSelected}"
                        (click)="toggleEventOutcome(bet, betOutcome, betTypeOutcome.name, betTypeShowType.betTypeName)" >
                            <span class="outcome-name">
                              <span class="name">{{betOutcome.name}}</span>
                            </span>
                            <span class="odd" *ngIf="expandedEvent.isPlayable && bet.isPlayable && betOutcome.isPlayable && betOutcome.odd > 1; else lockedOdd">{{betOutcome.odd | odd}}</span>
                            <ng-template #lockedOdd>
                              <span class="odd locked">
                                <!-- <i class="icon icon-ex-sm icon-lock"></i> -->
                                <app-svg-icon iconId="lock"></app-svg-icon>
                              </span>
                            </ng-template>
                        </div>
                    </div>
                    <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1 && k == 0">
                        <div class="sbv disabled">
                            <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                            <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                        </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #emptyOutcome>
                  <div class="outcome-wrap" *ngIf="bet.sbv">
                    <div class="outcome disabled">
                      <span class="outcome-name">
                        <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                          {{betTypeOutcome.name}}
                        </ng-container>
                        <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                          {{betTypeOutcome.shortName}}
                        </ng-container>
                      </span>
                      <span class="odd locked">
                        <app-svg-icon iconId="lock"></app-svg-icon>
                      </span>
                    </div>
                  </div>
                  <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1">
                    <div class="sbv disabled">
                      <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                      <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #sbvInBetTypeOrOutcome>
                <ng-container  *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
                  <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                    <div class="outcome-wrap">
                      <div class="outcome" [@blink-border]="betOutcome.odd"
                        [ngClass]="{'selected': betOutcome.isSelected}"
                        (click)="toggleEventOutcome(bet, betOutcome, betTypeOutcome.name, betTypeShowType.betTypeName)">
                          <span class="outcome-name">
                            <span class="name">{{betOutcome.name}}
                            <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                              <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                              <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                            </ng-container>
                            </span>
                          </span>
                          <span class="odd" *ngIf="expandedEvent.isPlayable && bet.isPlayable && betOutcome.isPlayable && betOutcome.odd > 1; else lockedOdd">{{betOutcome.odd | odd}}</span>
                          <ng-template #lockedOdd>
                            <span class="odd locked">
                              <!-- <i class="icon icon-ex-sm icon-lock"></i> -->
                              <app-svg-icon iconId="lock"></app-svg-icon>
                            </span>
                          </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #emptyOutcome>
                  <div class="outcome-wrap" *ngIf="bet.sbv">
                    <div class="outcome disabled">
                      <span class="outcome-name">
                        <span class="name">
                          <ng-container *ngIf="betTypeOutcome.mobileShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                            {{betTypeOutcome.name}}
                          </ng-container>
                          <ng-container *ngIf="betTypeOutcome.mobileShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                            {{betTypeOutcome.shortName}}
                          </ng-container>
                          <ng-container *ngIf="bet.sbv && betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                            <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                            <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                          </ng-container>
                        </span>
                      </span>
                      <span class="odd locked">
                        <app-svg-icon iconId="lock"></app-svg-icon>
                      </span>
                    </div>
                  </div>
                </ng-template>
              </ng-template>
          </ng-template>
        </div>

      </section>
    </div>
</section>
